import styled from "styled-components";

export const Styles = styled.div`
  .col {
    margin-bottom: 8rem;
  }

  .icon-avatar {
    background-color: var(--accent-primary-light);
    color: var(--on-accent-primary-light);

    border-radius: 99em;
    aspect-ratio: 1;

    display: flex;
    justify-items: center;
    align-items: center;
  }

  .icon-button {
    color: red;
    cursor: pointer;
  }

  .row span {
    color: var(--text-primary-light);
  }
`;
